import { ModalContent } from '@/components/Modal'

import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'
import { useOnCancel } from './ContextProvider'

export function Content() {
  const onCancel = useOnCancel()

  return (
    <ModalContent customCloseModal={onCancel} header={<Header />} footer={<Footer />}>
      <Body />
    </ModalContent>
  )
}
